import "./headerTeamCard.sass";

export default function HeaderTeamCard({ liga }) {

  return (
    <div className="team-card__header">
      <p>{liga}</p>
    </div>
  )
}